<template>
    <nav class="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0">
        <div class="-mt-px w-0 flex-1 flex">
            <a href="#" v-if="current_page - 1 > 0" @click.prevent="handleChangePage(current_page - 1)" class="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
                Previous
            </a>
        </div>
        <div class="hidden md:-mt-px md:flex">
            <template v-for="page in last_page">
                <span v-if="page === current_page" class="border-t-2 border-indigo-500 pt-4 px-4 inline-flex items-center text-sm font-medium text-indigo-600" aria-current="page">{{ page }}</span>

                <a v-else href="#" @click.prevent="handleChangePage(page)" class="border-t-2 border-transparent pt-4 px-4 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">{{ page }}</a>
            </template>
        </div>
        <div class="-mt-px w-0 flex-1 flex justify-end">
            <a href="#" v-if="current_page < last_page" @click.prevent="handleChangePage(current_page + 1)" class="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
                Next
            </a>
        </div>
    </nav>
</template>

<script>
export default {
    props: {
        current_page: Number,
        last_page: Number
    },
    methods: {
        handleChangePage(page) {
            this.$emit('change', page)
        }
    }
}
</script>
